var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"bg-color"}),(_vm.isPlaying)?_c('div',{staticClass:"badge inner"}):_vm._e(),_c('div',{staticClass:"badge outer"})])}
var staticRenderFns = []

export { render, staticRenderFns }